import { Contact } from '../contact/contact';

export class PostContactLienMembre extends Contact {
  public contactsLiensMembresRelationsID?: number;
  public premierContactID?: number;
  public secondContactID?: number;
  public telephone?: string;
  public email?: string;
  public fax?: string;
  public flagDelete?: number;
  public contactFonctionID?: number;
  public id: number;

  constructor(data?: Partial<PostContactLienMembre>) {
    super();
    Object.assign(this, data);
    this.setName((this.prenom ? this.prenom : '') + '' + (this.nom ? this.nom : ''));
  }
}
